<div
  #iconPicker="ngbPopover"
  class="mui-icon-picker"
  role="button"
  [id]="id"
  [attr.aria-label]="label"
  [ngbPopover]="popoverContent"
  [animation]="animation"
  [popoverClass]="'mui-popover mui-icon-picker__popover'"
  [placement]="['bottom', 'auto']"
  [triggers]="'manual'"
  tabindex="0"
  [ngClass]="{ 'mui-icon-picker--opened': iconPicker.isOpen(), 'has--error': !valid }"
  (click)="openPicker()"
  (focus)="openPicker()"
  (blur)="closePicker()"
  (keydown.arrowRight)="selectNextElement('right', $event)"
  (keydown.arrowDown)="selectNextElement('right', $event)"
  (keydown.arrowLeft)="selectNextElement('left', $event)"
  (keydown.arrowUp)="selectNextElement('left', $event)"
  (keydown.enter)="onElementSelect($event)"
  (keydown.space)="onElementSelect($event)">
  <mui-icon
    *ngIf="!value"
    class="mui-icon-picker__icon mui-icon-picker__icon--no-selection"
    [name]="deselectOptionIcon.name"
    [font]="deselectOptionIcon.font"></mui-icon>
  <mui-icon *ngIf="value" class="mui-icon-picker__icon" [name]="value.name" [font]="value.font"></mui-icon>
</div>

<ng-template #popoverContent>
  <div [attr.id]="popoverId" class="mui-icon-picker__options-container" role="menu" [attr.aria-labelledby]="id">
    <div
      *ngFor="let option of displayedOptions; let i = index"
      role="menuitem"
      class="mui-icon-picker__option"
      data-testid="mui-icon-picker-option"
      [ngClass]="{ 'mui-icon-picker__option--selected': isSelectedOption(option) }"
      [attr.data-element]="option ? option.font + '__' + option.name : 'deselect'"
      (click)="onOptionClick($event, option)">
      <mui-icon *ngIf="option === null" font="fa" name="ban" class="mui-icon-picker__icon mui-icon-picker__icon--no-selection"></mui-icon>
      <mui-icon *ngIf="option !== null" [font]="option.font" [name]="option.name" class="mui-icon-picker__icon"></mui-icon>
    </div>
  </div>
</ng-template>
